const labels: { [key in server.dto.MaritalStatuses]: string } = {
  divorced: RESX.MaritalStatuses.Divorced,
  married: RESX.MaritalStatuses.Married,
  neverMarried: RESX.MaritalStatuses.NeverMarried,
  widowed: RESX.MaritalStatuses.Widowed,
  unknown: RESX.GeneralLabels.Unknown
};

export const getMaritalStatus = (maritalStatus: server.dto.MaritalStatuses) => {
  return labels[maritalStatus];
};
